import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Heading from "./Heading";
import IMAGES from "../Images";

function Accordion({ title, hiddenPara, hiddenImg, parentfun, pd }) {
  const [active, setActive] = useState(false);
  const accordionDisplay = useRef(null);
  const [height, setHeight] = useState("0px");

  function toggleAccordion() {
    setActive(!active);
    setHeight(active ? "0px" : `${accordionDisplay.current.scrollHeight}px`);
    parentfun(hiddenImg);
  }

  return (
    <AccordionSection>
      <AccordionButton
        className={`accordion ${active ? "active" : ""}`}
        onClick={toggleAccordion}
        pd={pd}
      >
        <h5 style={{ fontSize: "18px", color: "black" }}>{title}</h5>
        <span style={{ marginLeft: "20px", fontSize: "20px" }}>
          {active ? "-" : "+"}
        </span>
      </AccordionButton>
      <AccordionContent
        ref={accordionDisplay}
        style={{ maxHeight: `${height}` }}
      >
        <p style={{ fontSize: "16px" }}>{hiddenPara}</p>
      </AccordionContent>
    </AccordionSection>
  );
}

export default Accordion;

const AccordionSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const AccordionButton = styled.div`
  color: #5e6ff9;
  cursor: pointer;
  //   padding: 18px 0px;
  padding: ${(props) => props.pd || "18px 0px"};
  display: flex;
  align-items: center;
  justify-content: space-between;
  outline: none;
  border-bottom: 1px solid #5e6ff9;
  transition: background-color 0.3s ease;

  .rotate {
    transform: rotate(90deg);
  }

  .accordion__icon {
    margin-left: auto;
    transition: transform 0.6s ease;
  }
`;

const AccordionContent = styled.div`
  padding-top: 15px;
  background-color: white;
  overflow: hidden;
  transition: max-height 0.2s ease;
`;
